import applyConverters from 'axios-case-converter';
import axios from 'axios';
import { CHANGE_DASHBOARD_LANGUAGE, ROOT_URL } from '../main/constants/endpoints';
import { DashboardLang } from '../constants/DashboardLang';
export const ERROR_API_RESPONSE_DATA = 'NO RESPONSE DATA';

export const changeDashboardLanguage = async (dashboardLanguageCode: DashboardLang): Promise<boolean> => {
    const client = applyConverters(axios.create());
    const response = await client.put(
        `${ROOT_URL}/${CHANGE_DASHBOARD_LANGUAGE}`,
        { dashboardLanguageCode },
        {
            withCredentials: true,
        }
    );

    if (response && response.data) {
        return true;
    }
    throw new Error(ERROR_API_RESPONSE_DATA);
};
